import { render, staticRenderFns } from "./OfferItem.vue?vue&type=template&id=fb796d66&"
import script from "./OfferItem.vue?vue&type=script&lang=js&"
export * from "./OfferItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports